import { Component, EventEmitter, OnInit, Output, signal } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ThemedSvgComponent } from '../themed-svg/themed-svg.component';

@Component({
  selector: 'app-splash-screen',
  standalone: true,
  imports: [TranslocoPipe, ThemedSvgComponent],
  template: `
    <div
      class="splash-screen absolute inset-0 z-50 flex flex-col items-center justify-center bg-surface-50"
      [class.is-fading]="fading()"
      aria-hidden="true"
    >
      <m-svg
        src="assets/images/stethoscope.svg"
        class="icon-box w-60 h-60 select-none -rotate-12"
      />

      <div class="mt-6 flex flex-col items-center text-center">
        <div class="text-3xl font-bold text-primary-700 tracking-wide">
          {{ 'splash.title' | transloco }}
        </div>
        <div class="mt-1 text-sm text-surface-500">
          {{ 'splash.subtitle' | transloco }}
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        position: absolute;
        inset: 0;
        z-index: 50;
        display: block;
      }

      .splash-screen {
        opacity: 1;
        transition: opacity 600ms ease;
      }

      .splash-screen.is-fading {
        opacity: 0;
        pointer-events: none;
      }

      .icon-box {
        animation: splash-pulse 3000ms ease-in-out infinite;
        will-change: transform;
      }

      @keyframes splash-pulse {
        0%,
        100% {
          transform: scale(1);
        }
        50% {
          transform: scale(1.05);
        }
      }
    `,
  ],
})
export class SplashScreenComponent implements OnInit {
  @Output() done = new EventEmitter<void>();

  protected readonly fading = signal(false);

  private readonly visibleMs = 3000;
  private readonly fadeMs = 600;

  ngOnInit(): void {
    setTimeout(() => {
      this.fading.set(true);
      setTimeout(() => this.done.emit(), this.fadeMs);
    }, this.visibleMs);
  }
}
